class MainAboutCompany extends HTMLElement {
  constructor() {
    super();

    this.radioInputs = this.querySelectorAll('.about-us__input');
    this.AboutUsContent = this.querySelectorAll('.about-us__content');
    this.customRadioBtns = this.querySelectorAll('.about-us__custom-radio');
    const mainlabel = this.querySelector('.main-label');
    this.prevHtml = mainlabel.innerHTML;
    this.handleRadioInputChange = this.handleRadioInputChange.bind(this);
    this.handleCustomRadioBtnClick = this.handleCustomRadioBtnClick.bind(this);

    this.initialContentHTML = this.AboutUsContent[0].innerHTML;

    this.init();
  }

  init() {
    this.radioInputs.forEach((radioInput, index) => {
      radioInput.addEventListener('change', this.handleRadioInputChange);
      this.toggleAboutUsContent(radioInput, index);
    });

    this.customRadioBtns.forEach((customRadioBtn) => {
      customRadioBtn.addEventListener('click', this.handleCustomRadioBtnClick);
    });
  }

  handleRadioInputChange(event) {
    this.radioInputs.forEach((radioInput, index) => {
      if (radioInput !== event.target) {
        this.AboutUsContent[index].classList.remove('about-us__content--visible');
        if (window.innerWidth > 846) {
          radioInput.parentNode.style.backgroundColor = '';
        }
      } else {
        if (window.innerWidth > 846) {
          radioInput.parentNode.style.backgroundColor = '#FFECCC';
        }
        if (index === 0) {
          this.AboutUsContent[index].innerHTML = this.initialContentHTML;
        }
        this.AboutUsContent[index].classList.add('about-us__content--visible');
      }
    });
  }

  handleCustomRadioBtnClick(event) {
    const customRadioBtn = event.target;
    const radioInput = customRadioBtn.previousElementSibling;
    radioInput.checked = true;
    if (window.innerWidth < 846) {
      const label = customRadioBtn.nextElementSibling;
      if (label) {
        const mainLabel = this.querySelector('.main-label');
        mainLabel.innerHTML = label.innerHTML;
        if ([...this.radioInputs].indexOf(radioInput) === 0) {
          mainLabel.innerHTML = this.prevHtml;
        }
        this.toggleAboutUsContent(radioInput, [...this.radioInputs].indexOf(radioInput));
      }
    } else {
      const mockEvent = { target: radioInput };
      this.handleRadioInputChange(mockEvent);
    }
  }
  toggleAboutUsContent(radioInput, index) {
    if (radioInput.checked) {
      if (window.innerWidth > 846) {
        radioInput.parentNode.style.backgroundColor = '#FFECCC';
      }
      this.AboutUsContent.forEach((element) => {
        element.classList.remove('about-us__content--visible');
      });
      this.AboutUsContent[index].classList.add('about-us__content--visible');
    } else {
      this.AboutUsContent[index].classList.remove('about-us__content--visible');
    }
  }
}

customElements.define('main-about-company', MainAboutCompany);
